import { PackageEvidence } from '@cadstrom/cadstrom-shared';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Tooltip from '@mui/material/Tooltip';
import clsx from 'clsx';

import { describeEvidenceConfidence } from './describe-evidence-confidence.js';

/** Props for {@link EvidenceConfidenceBadge}. */
export interface EvidenceConfidenceBadgeProps {
	/** The region's verdict and the votes it rests on. */
	confidence: PackageEvidence.EvidenceConfidence;
}

/**
 * A check for a region confirmed as evidence, a cross for one rejected, and nothing while it is only possible
 * evidence. Hovering says who decided and by what margin.
 */
export function EvidenceConfidenceBadge({ confidence }: EvidenceConfidenceBadgeProps) {
	const description = describeEvidenceConfidence(confidence);
	if (description === null) {
		return null;
	}
	const isConfirmed = confidence.verdict === PackageEvidence.EvidenceConfidenceVerdict.Confirmed;

	return (
		<Tooltip title={description}>
			<span
				role='img'
				aria-label={description}
				className={clsx('inline-flex items-center', isConfirmed ? 'text-green-11' : 'text-red-11')}
			>
				{isConfirmed ?
					<CheckCircleRoundedIcon aria-hidden style={{ fontSize: 16 }} />
				:	<CancelRoundedIcon aria-hidden style={{ fontSize: 16 }} />}
			</span>
		</Tooltip>
	);
}
